var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-footer"},[_c('figure',[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo/logo_transparent_dark.png"),"alt":"Tuin & Meer logo"},on:{"click":function($event){return _vm.scrollTop()}}}),_c('figcaption',[_vm._v(" © 2022 Jarno van der Meer ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }